import React from "react";
import { FluentProvider, teamsDarkTheme, Text, Divider } from "@fluentui/react-components";
import { ErrorCircleRegular } from "@fluentui/react-icons";
import { useTranslation } from "../../shared/translation/Translation";
import { observer } from "mobx-react-lite";
import styles from "../styles/inMeetingApp.module.scss";

interface WarningPromptProps {
    message: string;
}

const WarningPrompt: React.FC<WarningPromptProps> = observer((props: WarningPromptProps) => {
    const messages = useTranslation();
    const isPrivate = window.location.search.includes("businessLine=private");

    return (
        <FluentProvider theme={teamsDarkTheme}>
            <div className={styles.warningContent}>
                <ErrorCircleRegular style={{ fontSize: "48px" }} />
                <Divider />
                <Text align="center">{props.message}</Text>
            </div>
        </FluentProvider>
    );
});

export default WarningPrompt;
